// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1023) return "static/chunks/1023.958455358d2f9cd8.js";
	if (chunkId === 965) return "static/chunks/965.99e8bc879a63f761.js";
	if (chunkId === 576) return "static/chunks/576.3a4276cec71ab96b.js";
	if (chunkId === 234) return "static/chunks/234.a7285dc5695e24ff.js";
	if (chunkId === 7181) return "static/chunks/7181.95cab88f17c586cd.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"5647":"ca377847","9066":"dc112a36"}[chunkId] || chunkId) + "-" + {"2759":"7fe30b0ffdffd034","3821":"8464266c38cee4ab","5647":"a656bc88af7948f7","6699":"e572b645e6421edf","9066":"40c9096cfd93c91e","9753":"21a8e8af52eeea67"}[chunkId] + ".js";
};